define('drops/rectangle/rectangle',[
    'jquery',
    'lq/drop',
    'lq/style'
], function ($, Drop, Style) {
	'use strict';

    function Rectangle(options) {
        Drop.call(this, $('<div/>'), options);
       
        this.$element.addClass('boxToBorderSize')
            .attr('title', this.data.title);

        Style.renderStyles(this);
    }
    
    Drop.extend(Rectangle, Drop);

    Rectangle.typeName = 'Rectangle';

    Rectangle.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();
    };

    Rectangle.prototype.setValue = function (update) {
        this.setBackgroundColor(update.value);
    };
    
    Rectangle.prototype.clearValue = function () {
        this.setBackgroundColor('');
    };

    Rectangle.prototype.setBackgroundColor = function (color) {
        this.$element.css('background-color', color);
    };

	return Rectangle;
});
